<template>
  <div class="wrapper" id="wrapper">
    <div v-bind:style="{ width: widthWrapper }" class="ba-slider noSelect" :key="componentKey">
      <img class="img" id="image" :src="getRightImage" />
      <img class="topHole" :src="getTopHoleImage" />
      <div class="resize" id="resize">
        <img class="img2" :src="getLeftImage" />
      </div>
      <span class="handle" id="dragElement" @mousedown="mouseDown"></span>
      <div class="dotedLineTop doted" id="dragLine1"></div>
      <div class="dotedLineBottom doted" id="dragLine2"></div>
      <div class="arrow" id="arrow">
        <span class="arrowLeft">◄</span>
        <span class="arrowRight">►</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Photo',
  data() {
    return {
      componentKey: 0,
      maxSlider: 0,
      clicked: false,
      margeVerre: 15,
      imageDimensionLeft: 9,
      rightValue: '',
      widthWrapper: 0,
    };
  },
  beforeDestroy() {
    var imageWrapper = document.getElementById('wrapper');
    imageWrapper.style.height = 0;
  },
  computed: {
    getLeftImage() {
      return (
        '../../../demo/photo/compareSlider/' +
        this.$parent.LeftSelectedValue.id +
        '/' +
        this.$parent.LeftSelectedValue.id +
        '-' +
        this.situation.media.filename.replace(/[.]png$/, '.jpg')
      );
    },
    getRightImage() {
      return (
        '../../../demo/photo/compareSlider/' +
        this.$parent.RightSelectedValue.id +
        '/' +
        this.$parent.RightSelectedValue.id +
        '-' +
        this.situation.media.filename.replace(/[.]png$/, '.jpg')
      );
    },
    //get the current situation
    situation() {
      return this.$store.getters.getSituationById(this.$route.params.idSituation)[0];
    },
    clickedSlider: {
      get: function() {
        return this.clicked;
      },
      set: function(newValue) {
        this.clicked = newValue;
      },
    },
    getTopHoleImage() {
      return '../../../demo/photo/compareSlider/ImageWithHole-' + this.situation.media.filename;
    },
  },
  methods: {
    getCursorPos(e) {
      const image = document.querySelector('#image');

      const imageDimension = image.getBoundingClientRect();

      this.imageDimensionLeft = imageDimension.left;

      this.maxSlider = image.offsetWidth;

      return e.pageX - imageDimension.left;
    },
    slide(x) {
      let resize = document.querySelector('#resize');
      let slider = document.querySelector('#dragElement');
      let line1 = document.querySelector('#dragLine1');
      let line2 = document.querySelector('#dragLine2');
      let arrows = document.querySelector('#arrow');

      resize.style.width = x + 'px';
      /* Position the slider: */
      slider.style.left = resize.offsetWidth - slider.offsetWidth / 2 + 'px';
      line1.style.left = resize.offsetWidth - slider.offsetWidth / 2 + 'px';
      line2.style.left = resize.offsetWidth - slider.offsetWidth / 2 + 'px';
      arrows.style.left = resize.offsetWidth - slider.offsetWidth / 2 + 'px';
    },
    sliderMove(e) {
      let pos;
      if (!this.clickedSlider) {
        return false;
      } else {
        /* Get the cursor's x position: */
        pos = this.getCursorPos(e);

        let marge = (this.maxSlider * this.margeVerre) / 100;

        /* Prevent the slider from being positioned outside the image: */
        if (pos < marge) pos = marge;
        if (pos > this.maxSlider - marge) pos = this.maxSlider - marge;
        /* Execute a function that will resize the overlay image according to the cursor: */
        this.slide(pos);
      }
    },
    mouseDown() {
      this.clickedSlider = true;
    },
  },
  mounted() {
    this.widthWrapper = (document.getElementById('wrapper').clientHeight * 400) / 213 + 'px';
    let slider = document.querySelector('#dragElement');

    this.clickedSlider = false;
    window.addEventListener('touchmove', this.sliderMove);
    window.addEventListener('mousemove', this.sliderMove);
    window.addEventListener('mouseup', () => {
      this.clickedSlider = false;
    });
    window.addEventListener('touchend', () => {
      this.clickedSlider = false;
    });

    slider.addEventListener('touchstart', this.mouseDown);
  },
};
</script>

<style scoped>
.wrapper {
  height: 100%;
}
.ba-slider {
  position: relative;
  height: 100%;
}

.ba-slider .img {
  height: 100%;
  display: block;
}

.img2 {
  height: 100%;
}

.doted {
  position: absolute;
  width: 3px;
  height: 50%;
  background-image: repeating-linear-gradient(to right, white 0%, white 50%, transparent 50%, transparent 100%),
    repeating-linear-gradient(to right, white 0%, white 50%, transparent 50%, transparent 100%),
    repeating-linear-gradient(to bottom, white 0%, white 50%, transparent 50%, transparent 100%),
    repeating-linear-gradient(to bottom, white 0%, white 50%, transparent 50%, transparent 100%);
  background-position: left top, left bottom, left top, right top;
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 20px 3px, 20px 3px, 3px 20px, 3px 20px;
}

.dotedLineTop {
  left: 50%;
  top: -31px;
}

.dotedLineBottom {
  left: 50%;
  bottom: -2px;
}

.resize {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 50%;
  overflow: hidden;
}

.topHole {
  position: absolute;
  z-index: 10;
  height: 100%;
  top: 0px;
  left: 0px;
}

.noSelect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.arrow {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 10px;
  width: 10px;
  z-index: 11;
  color: white;
  font-size: 11px;
}

.arrowLeft {
  position: absolute;
  right: 32px;
  top: -21px;
}

.arrowRight {
  position: absolute;
  right: -26px;
  top: -21px;
}

.handle {
  /* Thin line seperator */
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  margin-left: -4px;
  cursor: ew-resize;
}

.handle:after {
  position: absolute;
  top: 50%;
  width: 36px;
  height: 36px;
  margin: -32px 0 0 -14px;

  content: '';
  color: white;
  font-weight: bold;
  font-size: 36px;
  text-align: center;
  line-height: 64px;

  border: 3px solid #ffffff; /* darken(@orange, 5%) */
  border-radius: 50%;
  transition: all 0.3s ease;
  z-index: 11;
}
</style>
